import Entity from "@/services/westore/entities/entity";

export class Product extends Entity {
  static uri = "/products";

  static search(params = {}) {
    return super.getAll(`${Product.uri}/search`, params);
  }

  static uploadProducts(payloadRequest) {
    return super.create(`${Product.uri}/import`, payloadRequest);
  }

  static getTemplate(params = {}) {
    return super.getAll(`${Product.uri}/template`, params);
  }

  // static export(params = {}) {
  //   const endpoint = `${Product.uri}/export`;
  //   return super.get(endpoint, null,params);
  // }

  static export(type = "xlsx") {
    const timestamp = Date.now();
    const endpoint = `${Product.uri}/export?type=${type}&datetime=${timestamp}`;
    return super.get(endpoint);
  }
}
